import React, { useState, useEffect, useRef, useContext } from "react";
import { Button, ConfirmDialog, Dialog, InputText, Toast } from "primereact";

import { useForm } from "../../../../Hooks/useForm";
import { toastShow } from "../../../../Services/ToastService";
import Loader from "../../../../Components/Loader/Loader";
import { AuthContext } from "../../../../Context/AuthContext/AuthContext";

import { addTypes, getObtenerTypes } from "../../../../API/Global/Types/TypeRequest";

const TypesCrudModal = ({
  tipo,
  tiposDialog,
  setTiposDialog,
  getTypes,
  modo,
  motivo = false,
}) => {
  const toast = useRef(null);
  const { userAuth } = useContext(AuthContext);

  const [tiposList, setTiposList] = useState([{}]);
  const [loading, setLoading] = useState(false);

  const initialValues = {
    IdType: -1,
    Type: "",
    TypeCategory: "",
  };

  const { values, handleInputChange, setValues, resetForm, error, setError } =
    useForm(initialValues);

  const getValoresIniciales = async () => {
    setLoading(true)
    const tiposL = await getObtenerTypes();
    setTiposList(tiposL);

    setValues({
      ...tipo,
      TypeCategory: motivo ? 'Motivos' : tipo?.TypeCategory,
    });
    setLoading(false)
  };

  const onHide = () => {
    setTiposDialog(false);
    resetForm();
  };

  const verificarInfo = () => {
    let error = {};
    if (!values.Type) {
      error.Type = true;
      error.error = true;
    }
    if (!values.TypeCategory) {
      error.TypeCategory = true;
      error.error = true;
    }
    setError(error);
    // console.log(error);
    return error;
  };

  const agregarType = async () => {
    const e = verificarInfo();
    const dialogTitle = modo === "Crear" ? "Registro Guardado exitosamente." : "Registro Actualizado exitosamente.";
    

    if (!e.error) {

      const existingType = tiposList.find((cur) => cur.Type === values?.Type && values?.IdType !== cur.IdType && values?.TypeCategory === cur.TypeCategory);
      if (existingType) {
        toastShow(
          toast,
          "error",
          "Error",
          "Ya existe una Tipo con ese nombre"
        );
      } else {
        const a = {
          IdType: values?.IdType,
          Type: values.Type,
          TypeCategory: values.TypeCategory,
          AbbreviatedType: values.AbbreviatedType,
          Descripcion: values.Descripcion,
          IdUserCreate: userAuth?.IdUser
        };
        const resultado = await addTypes(a);
        
        setLoading(true)
        // toastShow(toastRef, "success", "Datos Agregados", dialogTitle);
        toastShow(toast, "success", "Datos Agregados", dialogTitle);
        getTypes();
        setTimeout(() => {
          onHide();
          setLoading(false)
        }, 1000);
      }
    } else {
      toastShow(toast, "error", "Error", "Error al guardar la informacion");
    }
  };

  const generateAbbreviation = (type) => {
    return type.split(' ').map(word => word.substring(0, 2)).join('').toUpperCase();
  };

  const handleInputChangeWithAbbreviation = (e) => {
    const { name, value } = e.target;
    handleInputChange(e);
    if (name === 'Type') {
      setValues(prevValues => ({
        ...prevValues,
        AbbreviatedType: generateAbbreviation(value)
      }));
    }
  };

  const DialogFooter = (
    <React.Fragment>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        className="p-button-text"
        onClick={onHide}
      />
      <Button
        label={modo === "Crear" ? "Guardar" : "Modificar"}
        icon="pi pi-check"
        className="p-button-text"
        onClick={() => {agregarType()}}
        loading={loading}
      />
    </React.Fragment>
  );

  useEffect(() => {
    if (tiposDialog) {
      getValoresIniciales();
    }
  }, [tiposDialog]);

  const dialogTitle = motivo ? 'Agregar Motivo' : modo === "Crear" ? "Agregar Tipo" : "Modificar Tipo";

  return (
    <div>
      <Dialog
        visible={tiposDialog}
        modal
        className="modal__contenedor modal__usuarios"
        footer={DialogFooter}
        onHide={onHide}
      >
        <div id="typesDialog">
          <Loader loading={loading} querySelector={"#typesDialog"} />
          <Toast ref={toast} style={{ zIndex: 50000 }} />
          <ConfirmDialog />
          <div className="d-flex align-items-center">
            <h2 className="me-3">{dialogTitle}</h2>
          </div>

          <div className="modal__input-contenedor">
            <div className="field col-6 me-2">
              <span className="p-float-label">
                <InputText
                  name="Type"
                  value={values.Type}
                  onChange={handleInputChangeWithAbbreviation}
                  style={{ width: "100%" }}
                  abelStyle={{ color: "gray", textShadow: "0px 0px 1px white" }}
                  className={error.Type ? "p-invalid" : ""}
                />
                <label htmlFor="Type">{motivo ? 'Motivo de Pase' : 'Nombre de Tipo'}</label>
              </span>
            </div>

            <div className="field col-6 me-2">
              <span className="p-float-label">
                <InputText
                  name="TypeCategory"
                  value={values.TypeCategory}
                  onChange={handleInputChange}
                  style={{ width: "100%" }}
                  abelStyle={{ color: "gray", textShadow: "0px 0px 1px white" }}
                  className={error.TypeCategory ? "p-invalid" : ""}
                  disabled={motivo}
                />
                <label htmlFor="TypeCategory">Categoría de Tipo</label>
              </span>
            </div>
          </div>
          

          {!motivo && (
            <div className="modal__input-contenedor">
              <div className="field col-6 me-2">
                <span className="p-float-label">
                  <InputText
                    name="AbbreviatedType"
                    value={values.AbbreviatedType}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                  />
                  <label htmlFor="AbbreviatedType">Abreviación</label>
                </span>
              </div>

              <div className="field col-6 me-2">
                <span className="p-float-label">
                  <InputText
                    name="Descripcion"
                    value={values.Descripcion}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                  />
                  <label htmlFor="Descripcion">Descripción</label>
                </span>
              </div>
            </div>
          )}
        </div>
      </Dialog>
    </div>
  );
};

export default TypesCrudModal;
